// OLD CODE
// var $readMoreText = $('.c-read-more--text');

// function toggleReadMore($this) {

//     var $collapse = $this.find('.js-read-more-collapse'),
//         $expand = $this.find('.js-read-more-expand');

//     if ($collapse.hasClass('hidden')) { 
//         $expand.addClass('hidden');
//         $collapse.removeClass('hidden');

//         $this.prev().removeClass('is-active');

//     } else {
//         $collapse.addClass('hidden');
//         $expand.removeClass('hidden');
//         $this.prev().addClass('is-active');
//     }
// } 

// $('.js-read-more').on('click', function(e) {
//     e.preventDefault();

//     toggleReadMore($(this)); 
// });

$('.js-read-more a').on('click', function (e) {
    e.preventDefault();

    $(this).parent().prev('.c-read-more--text').toggleClass('read-more--textvisible')
});